<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Contrat - {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list-title modifier="perflist">
        Informations du vendeur
      </v-ons-list-title>
      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputFerme" label="Nom de l'exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputFerme" ref="inputFerme" v-model="infos.client.ferme" placeholder="Entrez un nom"></app-input>

        <app-label input-id="inputLigne4" label="Adresse de l'exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputLigne4" ref="inputLigne4" v-model="infos.client.ligne4" placeholder="Entrez une adresse"></app-input>

        <app-label input-id="inputCp" label="Code postal de votre exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputCp" ref="inputCp" input-type="tel" v-model="infos.client.cp" placeholder="Entrez un code postal"></app-input>

        <app-label input-id="inputVille" label="Commune de votre exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputVille" ref="inputVille" v-model="infos.client.ville" placeholder="Entrez une commune"></app-input>

        <template v-if="infos.client.name">
          <app-label input-id="inputName" label="Nom du représentant" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputName" ref="inputName" v-model="infos.client.name" placeholder="Entrez un nom"></app-input>
        </template>
        <template v-else>
          <app-label input-id="inputPrenom" label="Prénom du représentant" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputPrenom" ref="inputPrenom" v-model="infos.client.prenom" placeholder="Entrez un prénom"></app-input>

          <app-label input-id="inputNom" label="Nom du représentant" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputNom" ref="inputNom" v-model="infos.client.nom" placeholder="Entrez un nom"></app-input>
        </template>

        <app-label input-id="inputTel" label="Numéro de téléphone portable" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputTel" ref="inputTel" input-type="tel" v-model="infos.client.tel" placeholder="Entrez un 06/07"></app-input>

        <app-label input-id="inputEmail" label="Adresse email" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputEmail" ref="inputEmail" input-type="email" v-model="infos.client.email" placeholder="Entrez un email"></app-input>

        <app-label input-id="inputErp" label="Code tiers" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputErp" ref="inputErp" v-model="infos.client.erp" placeholder="Entrez un code tiers"></app-input>

        <template v-if="infos.client.silo !== undefined || negoceInfos.silo">
          <app-label input-id="inputSilo" label="Code silo" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputSilo" ref="inputSilo" v-model="infos.client.silo" placeholder="Entrez un code silo"></app-input>
        </template>

      </v-ons-list>

      <v-ons-list-title modifier="perflist">
        Détails du prix
      </v-ons-list-title>
      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputLivraison" label="Livraison"></app-label>
        <v-ons-list-item modifier="input">
          <textarea class="textarea textarea--transparent" rows="3" placeholder="Entrez les informations de livraison" v-model="infos.detail.livraison"></textarea>
        </v-ons-list-item>

        <app-label input-id="inputQualite" label="Qualité"></app-label>
        <v-ons-list-item modifier="input">
          <textarea class="textarea textarea--transparent" rows="3" placeholder="Entrez les informations de qualité" v-model="infos.detail.qualite"></textarea>
        </v-ons-list-item>

        <app-label input-id="inputPaiement" label="Paiement"></app-label>
        <v-ons-list-item modifier="input">
          <textarea class="textarea textarea--transparent" rows="3" placeholder="Entrez les informations de paiement" v-model="infos.detail.paiement"></textarea>
        </v-ons-list-item>

        <app-label input-id="inputObservation" label="Observations (optionnel)"></app-label>
        <v-ons-list-item modifier="input">
          <textarea class="textarea textarea--transparent" rows="3" placeholder="Entrez d'autres observations"
                    v-model="infos.detail.observation"></textarea>
        </v-ons-list-item>

      </v-ons-list>

      <template v-if="negoceInfos.is_signe">
        <v-ons-list-title modifier="perflist">
          Signature électronique
        </v-ons-list-title>
        <v-ons-list modifier="noborder perflist">
          <v-ons-list-item>
            <div class="left">
              <v-ons-checkbox input-id="checkboxSigne" modifier="material" :value="true" v-model="infos.is_signe"></v-ons-checkbox>
            </div>
            <label class="center" for="checkboxSigne">
              Activer la signature électronique
            </label>
          </v-ons-list-item>
        </v-ons-list>
      </template>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveContrat">
          Générer le contrat
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
        <a v-if="clientInfos" href="#" @click="callClient(venteClient, clientInfos, 'contrat edit')">
          <v-ons-icon icon="fa-phone"></v-ons-icon>
          Appeler l'agriculteur
        </a>
      </footer>
      
    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      indexVente: -1, // always set
      refCulture: '',
      refDestination: '',
      infos: {
        client: {
          ferme: '',
          ligne4: '',
          cp: '',
          ville: '',
          name: '',
          nom: '',
          prenom: '',
          tel: '',
          email: '',
          erp: '',
          silo: undefined
        },
        detail: {
          livraison: '',
          qualite: '',
          paiement: '',
          observation: ''
        },
        is_signe: true
      },
      venteId: '',
      venteClient: '',
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    clientInfos() {
      return this.data.negoce.clients[this.venteClient];
    },
    negoceInfos() {
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    }
  },
  methods: {
    async saveContrat() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();


      if (!this.infos.client.ferme) {
        this.setErrorMsgList('inputFerme', "Le nom de l'exploitation est obligatoire");
      }

      if (!this.infos.client.ligne4) {
        this.setErrorMsgList('inputLigne4', "L'adresse de la ferme est obligatoire");
      }

      if (!this.infos.client.cp) {
        this.setErrorMsgList('inputCp', "Le code postal de la ferme est obligatoire");
      } else if (this.infos.client.cp != 'N/C') {
        var cpRegex = /^\d{4}\d?$/; // cp belge 4 digits
        if (!cpRegex.test(this.infos.client.cp)) {
          this.setErrorMsgList('inputCp', "Le code postal n'a pas un format valide");
        }
      }

      if (!this.infos.client.ville) {
        this.setErrorMsgList('inputVille', "La ville de la ferme est obligatoire");
      }

      if(!this.infos.client.name){
        if (!this.infos.client.prenom) {
          this.setErrorMsgList('inputPrenom', "Le prénom est obligatoire");
        }
        if (!this.infos.client.nom) {
          this.setErrorMsgList('inputNom', "Le nom est obligatoire");
        }
      }

      if (!this.infos.client.tel) {
        this.setErrorMsgList('inputTel', "Le téléphone est obligatoire");
      } else if (this.infos.client.tel != 'N/C') {
        var telRegex = /^(((\+|00)33|0)\s*[1-9]|(\+|00)32\s*4)([\s.-]*\d{2}){4}$/;
        if (!telRegex.test(this.infos.client.tel)) {
          this.setErrorMsgList('inputTel', "Le numéro de téléphone n'a pas un format valide");
        }
      }

      if (!this.infos.client.email) {
        this.setErrorMsgList('inputEmail', "L'email est obligatoire");
      } else if (this.infos.client.email != 'N/C') {
        var emailRegex = /^([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)@(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,})$/;
        if (!emailRegex.test(this.infos.client.email)) {
          this.setErrorMsgList('inputEmail', "L'email n'a pas un format valide");
        }
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.venteId,
        data: {
          client: {},
          detail: {}
        }
      };
      for (const key in this.infos.client) {
        body.data.client[key] = this.infos.client[key];
      }
      for (const key in this.infos.detail) {
        body.data.detail[key] = this.infos.detail[key].split("\n");
      }
      if(this.negoceInfos.is_signe){
        body.is_signe = this.infos.is_signe;
      }

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/contrat');
      try {
        const response = await this.handleRequest(callPath, fetchInit);
        
        this.updateUserFromResponse(response.user);

        this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
        this.$showToast('Contrat transmis par email');
      } catch(error) {
          this.handleError(error);
      }
    }
  },
  created() {
    this.setJson(this.infos.client, this.strategie.done[this.indexVente].contrat.client);
    for (const key in this.infos.detail) {
      if(this.strategie.done[this.indexVente].contrat.detail[key]){
        this.infos.detail[key] = this.strategie.done[this.indexVente].contrat.detail[key].join("\n");
      }
    }
    this.venteClient = this.strategie.done[this.indexVente].client;
    this.venteId = this.strategie.done[this.indexVente].id;
  }
}
</script>
